import React, { useState } from "react";
import { Box, Button, Flex, Heading, Link, Text } from "@reverb-ui/react";
import { colors } from "@reverb-ui/tokens";
import { Carousel } from "./carousel";
import { ArrowRight } from "@reverb-ui/icons-react";
export var FeaturedBannerBox = function (_a) {
    var banners = _a.banners;
    var _b = useState(0), bannerActiveIndex = _b[0], setBannerActiveIndex = _b[1];
    var hasManyBanners = banners.length > 1;
    return (React.createElement(Flex, { mx: "6", flex: "1", alignItems: "center" },
        banners[bannerActiveIndex].image,
        React.createElement(Box, { flex: "1", px: "12", textAlign: "start" },
            React.createElement(Heading, { fontWeight: "bold", pb: "6" }, banners[bannerActiveIndex].title),
            React.createElement(Text, { color: colors.gray[900] }, banners[bannerActiveIndex].description),
            banners[bannerActiveIndex].callToActionButton && (React.createElement(Link, { _hover: { textDecoration: "none" }, target: "_blank", href: banners[bannerActiveIndex].callToActionButton.link },
                React.createElement(Button, { mt: "6", colorScheme: "blue", bg: "blue.500", rightIcon: React.createElement(ArrowRight, { color: "white" }) }, banners[bannerActiveIndex].callToActionButton.label))),
            hasManyBanners && (React.createElement(Carousel, { iterableElement: banners, currentIndex: bannerActiveIndex, setCurrentIndex: function (bannerActiveIndex) {
                    return setBannerActiveIndex(bannerActiveIndex);
                } })))));
};
